export * from "ce/pages/Editor/IDE/Header/useLibraryHeaderTitle";
import useCELibraryHeaderTitle from "ce/pages/Editor/IDE/Header/useLibraryHeaderTitle";

function useLibraryHeaderTitle() {
  const ceLibraryHeaderTitle = useCELibraryHeaderTitle();
  // const showQueryModule = useSelector(getShowQueryModule);

  // if (showQueryModule) return "";

  return ceLibraryHeaderTitle;
}

export default useLibraryHeaderTitle;
